module.exports = __webpack_public_path__ + "pet2.png?d94562af28a886d938a9f1e885e8d939";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pet2.png
// module id = 99
// module chunks = 0